/* @flow */
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const BIZ_DATA = 'BIZ_DATA';
export const AUTH_ACCESS_TOKEN = 'AUTH_ACCESS_TOKEN';
export const REPORTS_LIST = 'REPORTS_LIST';
export const REPORT_LIST_DETAIL = 'REPORT_LIST_DETAIL';

export default {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  BIZ_DATA,
  AUTH_ACCESS_TOKEN,
  REPORTS_LIST,
  REPORT_LIST_DETAIL,
};
